<template>
  <ul class="list-buildings" v-if="notes.length > 0" role="presentation">
    <note-block v-for="note in notes" :key="note.id" :note="note" />
  </ul>
  <ul class="list-buildings" v-else role="presentation">
    <li class="build error" role="presentation">
      <p>{{ $t("message.nothingError") }}</p>
    </li>
  </ul>
</template>

<script>
import NoteBlock from './NoteBlock'

export default {
  name: 'NoteList',
  components: {
    NoteBlock
  },
  props: {
    notes: {
      type: Array,
      default: () => []
    }
  }
}
</script>
